import React, { useEffect, useState } from "react";
import {
  Card,
  Table,
  Input,
  message,
  InputNumber,
  Button,
  Select,
  Modal,
} from "antd";

import {
  SearchOutlined,
  InboxOutlined,
  HistoryOutlined,
} from "@ant-design/icons";

import {
  getIngredients,
  deductIngredientStock,
  getIngredientHistory,
  getIngredientsFromExpenses,
} from "../../api/foodstockApi";

export default function RecipePage() {
  const [ingredients, setIngredients] = useState([]);
  const [search, setSearch] = useState("");

  const [takeQty, setTakeQty] = useState({});
  const [takeUnit, setTakeUnit] = useState({});

  // ✅ HISTORY STORAGE
  const [history, setHistory] = useState({});

  const [openTake, setOpenTake] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  

  // ================= FETCH =================
  const fetchIngredients = async () => {
    try {
      const res = await getIngredients();

      const mapped = (res.data || []).map((i) => ({
        id: i.id,
        name: i.name,
        unit: i.unit,

        // remaining stock after deduction
        qty: Number(i.qty || 0),

        total_stock: Number(i.total_stock || 0),
        remaining_stock: Number(i.remaining_stock || 0),

        rate: Number(i.rate || 0),
      }));

      setIngredients(mapped);
    } catch (err) {
      message.error("Failed to load ingredients");
    }
  };

 useEffect(() => {
  fetchIngredients();
}, []);

useEffect(() => {

  const loadAllHistory = async () => {

    try {

      const res = await getIngredients();

      const items = res.data || [];

      const historyMap = {};

      for (const item of items) {

        const historyRes =
          await getIngredientHistory(item.id);

        historyMap[item.id] =
          (historyRes.data || []).filter(
            (h) => h.type === "OUT"
          );
      }

      setHistory(historyMap);

    } catch (err) {
      console.log(err);
    }
  };

  loadAllHistory();

}, []);

  // ================= TAKE STOCK =================

  const openTakeModal = (record) => {
    setSelectedItem(record);
    setOpenTake(true);
  };

  const handleTake = async (record) => {
  const qty = Number(takeQty[record.id] || 0);
  const unit = takeUnit[record.id] || record.unit;

  if (!qty || qty <= 0) {
    message.error("Enter valid quantity");
    return;
  }

  try {
    await deductIngredientStock(record.id, { qty, unit });

    message.success("Stock updated");

    fetchIngredients();

    const res = await getIngredientHistory(record.id);

    setHistory((prev) => ({
      ...prev,
      [record.id]: (res.data || []).filter(
        (item) => item.type === "OUT"
      ),
    }));

    setTakeQty({
      ...takeQty,
      [record.id]: "",
    });

    setOpenTake(false);

  } catch (err) {
    message.error(err?.response?.data?.message || "Failed");
  }
};


  ///=======load history on expand ===========
 const loadHistory = async (id) => {
  try {
    const res = await getIngredientHistory(id);

    setHistory((prev) => ({
      ...prev,
      [id]: (res.data || []).filter(
        (item) => item.type === "OUT"
      ),
    }));

  } catch (err) {
    message.error("Failed to load history");
  }
};

  // =================   search  =================
const filtered = ingredients.filter((i) => {
  // SEARCH FILTER
  const matchesSearch = i.name
    ?.toLowerCase()
    .includes(search.toLowerCase());

  if (!matchesSearch) return false;

  // NO DATE / HISTORY FILTER ANYMORE
  return true;
});

  // ================= HISTORY TABLE =================
  const historyColumns = [
    {
      title: "Qty Used",
      dataIndex: "required_qty",
       render: (value) => {
        const num = Number(value || 0);
        return Number.isInteger(num) ? num : num.toFixed(2).replace(/\.00$/, "");
      },
    },
    {
      title: "Unit",
      dataIndex: "unit",
    },
    {
      title: "Time",
      dataIndex: "created_at",
     render: (value) => {
  if (!value) return "-";

  const date = new Date(value);

  // subtract 5 hours 30 minutes
  date.setHours(date.getHours() - 5);
  date.setMinutes(date.getMinutes() - 30);

  return date.toLocaleString();
},
    },
  ];

  // ================= MAIN TABLE =================
  const columns = [
    {
      title: "Name",
      dataIndex: "name",
    },

    {
      title: "Total Stock",
      render: (_, r) => `${r.total_stock} ${r.unit}`,
    },

    {
      title: "Remaining Stock",
      render: (_, r) => {

        const stock = Number(r.remaining_stock || 0);

        if (stock <= 0) {
          return (
            <span
              style={{
                color: "red",
                fontWeight: 600,
              }}
            >
              Out of Stock
            </span>
          );
        }

        return `${stock} ${r.unit}`;
      },
    },

    {
      title: "Action",
      render: (_, record) => (
        <Button
          type="primary"
          onClick={() => openTakeModal(record)}
        >
          Take
        </Button>
      ),
    },
  ];

  return (
    <Card
      bordered={false}
      style={{
        background: "#f5f5f5",
      }}
    >
      {/* ===== PAGE HEADER ===== */}
      <div
  style={{
    background: "#fff",
    borderRadius: 12,
    padding: "18px 20px",
    marginBottom: 16,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
    boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
  }}
>
  {/* LEFT SIDE - TITLE */}
  <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
    <InboxOutlined
      style={{
        fontSize: 50,
        color: "#1677ff",
      }}
    />

    <div>
      <div style={{ fontSize: 22, fontWeight: 700 }}>
        Stock Consumption
      </div>

      <div style={{ color: "#777", marginTop: 4 }}>
        Track used ingredients and available stock balance
      </div>
    </div>
  </div>

  {/* RIGHT SIDE - SEARCH */}
  <Input
    placeholder="Search"
    prefix={<SearchOutlined />}
    value={search}
    onChange={(e) => setSearch(e.target.value)}
    style={{
      width: 280,
      background: "#fff",
      borderRadius: 8,
    }}
  />
</div>
<Table
  dataSource={filtered}
  columns={columns}
  rowKey="id"
  bordered={false}
  expandable={{
    expandRowByClick: true,

    onExpand: (expanded, record) => {
      if (expanded) loadHistory(record.id);
    },

    expandedRowRender: (record) => {
  const allHistory = history[record.id] || [];

  return (
    <div
      style={{
        padding: 20,
        display: "flex",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: 700,   // ✅ keeps it centered & clean
        }}
      >
        {/* HEADER CARD */}
        <div
          style={{
            background: "#fff",
            padding: "12px 16px",
            borderRadius: 10,
            marginBottom: 12,
            display: "flex",
            alignItems: "center",
            gap: 10,
            boxShadow: "0 1px 5px rgba(0,0,0,0.05)",
          }}
        >
          <HistoryOutlined
            style={{
              color: "#1677ff",
              fontSize: 18,
            }}
          />

          <div style={{ fontWeight: 600, fontSize: 16 }}>
            Usage History
          </div>
        </div>

        {/* TABLE */}
        <div
          style={{
            background: "#fff",
            padding: 10,
            borderRadius: 10,
            boxShadow: "0 1px 5px rgba(0,0,0,0.05)",
          }}
        >
          <Table
            size="small"
            columns={historyColumns}
            dataSource={allHistory}
            pagination={false}
            rowKey="id"
            locale={{ emptyText: "No usage yet" }}
          />
        </div>
      </div>
    </div>
  );
}
  }}
/>
      {/* ===== TAKE MODAL ===== */}
      <Modal
        open={openTake}
        title="Take Ingredient"
        onCancel={() => setOpenTake(false)}
        footer={null}
      >
        {selectedItem && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 15,
            }}
          >
            <div>
              <b>Available:</b>{" "}
              {selectedItem.remaining_stock}{" "}
              {selectedItem.unit}
            </div>

            <InputNumber
              placeholder="Qty"
              style={{ width: "100%" }}
              value={takeQty[selectedItem.id]}
              onChange={(val) =>
                setTakeQty({
                  ...takeQty,
                  [selectedItem.id]: val,
                })
              }
            />

            <Select
              value={
                takeUnit[selectedItem.id] ||
                selectedItem.unit
              }
              style={{ width: "100%" }}
              onChange={(val) =>
                setTakeUnit({
                  ...takeUnit,
                  [selectedItem.id]: val,
                })
              }
            >
              <Select.Option value="gm">gm</Select.Option>
              <Select.Option value="kg">kg</Select.Option>
              <Select.Option value="ml">ml</Select.Option>
              <Select.Option value="ltr">ltr</Select.Option>
            </Select>

            <Button
              type="primary"
              onClick={() => handleTake(selectedItem)}
            >
              Submit
            </Button>
          </div>
        )}
      </Modal>
    </Card>
  );
}